import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import WidgetTemplate from './Template'

const HeaderControl = (props) => {
  return <WidgetTemplate props={props} layout="header" />
}

export const headerControlTester = rankWith(3, scopeEndsWith('header'))

export default withJsonFormsControlProps(HeaderControl)
